import { Reveal, MaskedLines } from "@/components/motion";

const PageHero = ({ overline, title, lead, testId }) => (
  <section data-testid={testId} className="border-b border-hairline">
    <div className="mx-auto max-w-7xl px-4 pb-16 pt-32 sm:px-6 sm:pt-40 lg:px-8 lg:pb-24 lg:pt-48">
      <Reveal y={14}>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted">{overline}</p>
      </Reveal>
      <h1 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-charcoal sm:text-5xl lg:text-7xl">
        <MaskedLines lines={Array.isArray(title) ? title : [title]} delay={0.15} />
      </h1>
      {lead && (
        <Reveal delay={0.55} className="mt-8 max-w-2xl">
          <p className="text-lg font-light leading-relaxed text-graphite sm:text-xl">{lead}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
